import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";

class BusinessProfile extends Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  state = {
    activeIndex: 0,
    rows: [],
  };

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const rows = [];
    if (props.node !== undefined) {
      rows.push(
        <Table.Row key={`Row_Profile_Name`}>
          <Table.Cell>Company Name</Table.Cell>
          <Table.Cell>{_.get(props.node, "companyName[0]._")}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`Row_Profile_Phone`}>
          <Table.Cell>Phone Numnber</Table.Cell>
          <Table.Cell>{_.get(props.node, "phone[0]._")}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`Row_Profile_Address`}>
          <Table.Cell>Address</Table.Cell>
          <Table.Cell>{_.get(props.node, "address[0]._")}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`Row_Profile_City`}>
          <Table.Cell>City, State {"&"} ZIP</Table.Cell>
          <Table.Cell>{`${_.get(props.node, "city[0]._")} ${_.get(
            props.node,
            "state[0]._"
          )} ${_.get(props.node, "zip[0]._")}`}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`Row_Profile_Site`}>
          <Table.Cell>Web site</Table.Cell>
          <Table.Cell>
            <a target="new" href={_.get(props.node, "url[0]._")}>
              {_.get(props.node, "url[0]._")}
            </a>
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`Row_Profile_Employees`}>
          <Table.Cell>Number of Employees</Table.Cell>
          <Table.Cell>
            {_.get(props.node, "employeestotaldescription[0]._")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`Row_Profile_Revenue`}>
          <Table.Cell>Annual Revenue</Table.Cell>
          <Table.Cell>
            {_.get(props.node, "salesvolumedescription[0]._")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`Row_Profile_Type`}>
          <Table.Cell>Type Of Business</Table.Cell>
          <Table.Cell>{_.get(props.node, "sic01description[0]._")}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`Row_Profile_Years`}>
          <Table.Cell>Years In Business</Table.Cell>
          <Table.Cell>{_.get(props.node, "yearsinbusiness[0]._")}</Table.Cell>
        </Table.Row>
      );
    }
    this.state = { rows, activeIndex: 0 };
  };

  render() {
    return (
      <Accordion fluid styled key={`Business_Section_Profile`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Business_Profile_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Business Profile
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Business_Profile_Body`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{this.state.rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default BusinessProfile;



// WEBPACK FOOTER //
// ./src/components/reports/Business/BusinessProfile.js